import { OnboardingSteps, NodeElement } from '../types';

import evaluateConditions from './evaluateConditions';

const getFirstMatching = (
  elements: NodeElement[],
  steps: OnboardingSteps,
  formOptions: Record<string, unknown>
) => {
  // this is the first element in the node to match all the conditions (aka, order matters)
  // if this is undefined, it means that no steps have their conditions met and our
  // flow is broken
  for (const element of elements) {
    if (!element.condition) {
      return element;
    }

    if (evaluateConditions(element.condition, steps, formOptions)) {
      return element;
    }
  }
};

export default getFirstMatching;
